<!-- 服务支持 -->
<template>
  <div class="help-main">
    <div class="help-main-left">
      <ul class="zlr-menu">
        <li v-for="(ServiceItem,index) in ServiceObject"
            :key="index">
          <a @click="linkHandle(ServiceItem, true)"
             :class="[ServiceItem.title ===curData.title? 'active': '']">{{ServiceItem.title}}</a>
          <template v-if="ServiceItem.courseWareList && ServiceItem.courseWareList.length">
            <ul class="zlr-menu-child">
              <li v-for="(child,childIndex) in ServiceItem.courseWareList"
                  :key="childIndex">
                <a :class="[child.title ===curData.title? 'active': '']"
                   @click="linkHandle(child)">{{child.title}}</a>
              </li>
            </ul>
          </template>
        </li>
      </ul>
    </div>
    <div class="help-main-right">
      <template v-if="isLook">
        <pdf-preview :url="curData.url" :password="curData.password"></pdf-preview>
      </template>
      <ul class="attachments-down"
          v-if="curData.attachments&&curData.attachments.length">
        <li v-for="(item, index) in curData.attachments"
            :key="index"><a :href="item.url">{{item.title}} 下载 </a></li>
      </ul>
    </div>
  </div>
</template>

<script>
//  constant
import ServiceSupport from '@/constant/service-support'
// api
import { infoQueryDetail } from '@/api/info'
import doc from '@/constant/documents'
import PdfPreview from '@/view/components/pdf-preview/index'
import newDoc from '@/constant/new-document'
import _ from 'lodash'
import isAllowEdit from '@/view/mixins/is-edit'
export default {
  name: 'help-main',
  components: { PdfPreview },
  mixins: [isAllowEdit],
  data () {
    return {
      ServiceObject: {},
      curData: {
      },
      isLook: false
    }
  },
  computed: {},
  mounted () {
    console.log(this.isallowedit)
    this.getDetail()
    this.lookPdf = _.debounce(this.sureLookPdf, 1000)
  },
  methods: {
    getDetail () {
      infoQueryDetail({}).then(res => {
        let model = res.data.model
        // 须知文档
        let ServiceObject = {
          '学员手册': {
            title: '学员手册',
            url: 'https://res.zailairen.com/msp/docs/1.0/1.999%20User\'s%20Manual-Mentee%20Service%20Platform.pdf'
          },
          'Zoom使用': {
            title: 'Zoom使用',
            url: 'https://res.zailairen.com/msp/docs/1.0/1.998%20%E5%86%8D%E6%9D%A5%E4%BA%BAZoom%20%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C-%E5%AD%A6%E5%91%98%E7%89%88%202019%20v1.pdf'
          }
        }
        let docsType = this.inYearDocsType(model.inYear)
        let plan = model.packageInfo && model.packageInfo.detail && model.packageInfo.detail.plan
        let packageType = model.packageInfo && model.packageInfo.detail && model.packageInfo.detail.packageType
        let customerManual = []
        let password = 'Zailairen20'
        if (model.packageId) {
          customerManual = newDoc.filter(item => !item.packageId || ((item.packageId === model.packageId) && (!!model.packageInfo.longLine === item.longLine)))
          if (!customerManual || customerManual.length < 2) {
            customerManual = doc.filter(item => (!item.type || item.type === docsType) && (!item.plan || item.plan === plan) && (!item.packageType || item.packageType === packageType))
            password = 'Zailairen19'
          }
        } else {
          customerManual = doc.filter(item => (!item.type || item.type === docsType) && (!item.plan || item.plan === plan) && (!item.packageType || item.packageType === packageType))
          password = 'Zailairen19'
        }
        customerManual.forEach(item => {
          ServiceObject[item.title] = {
            title: item.title,
            url: item.url,
            password: password
          }
        })
        // 服务支持
        let Servicetype = this.inYearServiceType(model.inYear)
        let titleArr = Object.keys(ServiceSupport)
        titleArr.forEach(title => {
          ServiceObject[title] = {
            title: ServiceSupport[title].title,
            courseWareList: ServiceSupport[title].courseWareList.filter((item) => (item.targetMenteeType === Servicetype || item.targetMenteeType === 'ALL'))
          }
        })
        this.ServiceObject = ServiceObject
        this.curData = ServiceObject['学员手册']
        this.isLook = true
      })
    },
    inYearServiceType (num) {
      let year = (new Date()).getFullYear()
      let type = ''
      switch (num - year) {
        case 0:
        case 1:
          type = 'IN_SEASON'
          break
        case 2:
        case 3:
          type = 'LONG_TERM'
          break
      }
      return type
    },
    inYearDocsType (num) {
      let year = (new Date()).getFullYear()
      let type = ''
      switch (num - year) {
        case 0:
        case 1:
          type = 'apply'
          break
        case 2:
          type = 'normal'
          break
        case 3:
          type = 'earlyBird'
          break
      }
      return type
    },
    linkHandle (item, isTab) {
      if (this.isallowedit) {
        this.isLook = false
        if (isTab) {
          if (item.url) {
            this.curData = item
          }
        } else {
          this.curData = item
        }
        this.lookPdf()
      } else {
        if (item.title === '学生手册') {
          this.lookPdf()
        }
      }
    },
    sureLookPdf () {
      this.isLook = true
    }
  }
}
</script>
<style lang='less' scoped>
.help-main {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  padding-top: 40px;
  justify-content: space-between;
  &-left {
    width: 300px;
    background-color: #fff;
    max-height: calc(100vh);
    overflow-x: hidden;
    overflow-y: auto;
    .zlr-menu {
      width: 100%;
    }
  }
  &-right {
    width: 960px;
    background-color: #fff;
  }
}

.zlr-menu {
  width: 300px;
  list-style: none;
  padding-top: 20px;
  a {
    display: inline-block;
    width: 100%;
    height: auto;
    line-height: 1.2;
    padding: 10px 0;
    color: rgba(0, 0, 0, 0.85);
    transition: all 0.3s ease-in-out;
  }

  li {
    width: 100%;
  }

  > li {
    margin-bottom: 10px;

    > a {
      padding-left: 10px;
    }
  }

  &-child {
    a {
      padding-left: 20px;
      padding-right: 4px;
      font-size: 12px;
    }
  }

  &-disabled {
    pointer-events: none;
  }

  a:hover {
    background-color: @c-primary;
    color: #ffffff;
  }

  a.active {
    background-color: @c-primary;
    color: #ffffff;
  }
}

iframe {
  width: 960px;
  min-height: calc(100vh);
}

.attachments-down {
  li {
    padding: 10px;
  }
}
</style>
